<div class="config-popup-container">
    <div class="heading">
        <span class="heading_text">New Configuration</span>
        <span class="close" (click)="closePopup()"><img src="/assets/img/close.svg"></span>
    </div>
    <div class="config-popup-body">
        <app-config-fields #config_back [data]="configType" (onShowTabs)="hideOrShowButton($event)"></app-config-fields>
    </div>
    <div class="config-popup-footer" *ngIf="buttonText !== undefined && buttonText !== null && buttonText !== '' && showButton">
        <button type="button" class="back_button" *ngIf= "tabLabel != undefined && tabLabel > 0" (click)="validateOnBackButtonClick()">Back</button>
        <button type="button" class="save-button" (click)="openConfirmPopup()">{{buttonText}}</button>
    </div>
</div>